import React from 'react'
import PropTypes from 'prop-types'
import Image from '../image/image'

import './caseStudyHero.css'

const CaseStudyHero = ({ data }) => {
  return (
    <section className="caseStudyHero">
      <Image file={data.featuredImage} alt="project image" width={'100%'} height={700}></Image>
      <div className="content">
        <p>{data.client}</p>
        <h1>{data.title}</h1>
      </div>
    </section>
  )
}

CaseStudyHero.propTypes = {
  data: PropTypes.object,
}

export default CaseStudyHero
